import { graphql, useStaticQuery } from 'gatsby';
import React, { Fragment } from 'react';

const DealerRelatedMakes = ({dealer, make}) => {
  const data = useStaticQuery(graphql`
    query {
      allSanityMake{
        edges {
          node {
            _id
            name
            logo {
              asset {
                url
              }
            }
            dealers {
              dealer {
                _id
              }
            }
          }
        }
      }
    }`
  );

  const makes = data.allSanityMake?.edges.map((d) => {
    return d.node;
  });

  let relatedMakes = [];

  makes.forEach(m => {
    m.dealers.forEach(d => {
      if (d.dealer._id === dealer._id && m._id !== make._id) {
        relatedMakes.push(m);
      }
    })
  });

  return (
    relatedMakes.length > 0 &&
    <section>
        <h3 className="text-xl font-bold mb-4">Other Brands from {dealer.name}</h3>
          <div className="flex flex-row">
          {relatedMakes.map((make, i) => (
            <div key={i}>
              <img className="h-16" src={make.logo.asset.url} alt={make.name} loading="lazy" />
            </div>
          ))}
        </div>
    </section>
  );
}

export default DealerRelatedMakes;
